import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import * as insightsAPI from '@debbie/cortex/dist/api/insights.js';
import { PlaceholderLoader } from '..//index.js';
import ExternalLink from '../Icons/ExternalLink.js';
const CaseFilterQueue = (props) => {
    const caseFilter = useSelector((s) => s.caseFilter);
    const [loading, setLoading] = useState(false);
    return loading ? (React.createElement(PlaceholderLoader, { width: "16px", height: "15px", inline: true })) : (React.createElement(ExternalLink, { style: { margin: '0.2em 0 -0.2em', cursor: 'pointer' }, onClick: async () => {
            setLoading(true);
            const caseQueue = await insightsAPI.getCaseFilterQueue({
                ...caseFilter,
                ...props.appendToCaseFilter,
            });
            c.redirect.redirect(`/cases/${caseQueue.join(',')}`);
            setLoading(false);
        }, id: "ui-test-5e51e31e" }));
};
export default CaseFilterQueue;
//# sourceMappingURL=CaseFilterQueue.js.map